import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & .buttonWrapper {
    display: flex;
    grid-gap: 10px;
    padding: 10px 0 0;
  }

  & p {
    text-transform: capitalize;
  }
`;
